import { c as _c } from "react/compiler-runtime";
export default function ProfileActivityLogItemAction(t0) {
  const $ = _c(2);
  const {
    action
  } = t0;
  let t1;
  if ($[0] !== action) {
    t1 = <span className="tw-whitespace-nowrap tw-text-sm lg:tw-text-base tw-text-iron-500 tw-font-normal empty:tw-hidden">{action}</span>;
    $[0] = action;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}